'use client';

import { Dispatch, FC, ReactNode, SetStateAction, useState } from 'react';
import { createContext } from 'use-context-selector';

import { checkContext } from '../context-utils';
import { MembershipProductContextType } from './membership-product-context-type';

export const IntialMemberhipProductContextState: MembershipProductContextType = {
  editMode: false,
  product: null,
  isAdminAccess: false,
  joinAction: { showConfirmation: false, versionId: '' },
};

export const MembershipProductContext = createContext<
  [MembershipProductContextType, Dispatch<SetStateAction<MembershipProductContextType>>] | null
>(null);

export const setMembershipProductContextState = (
  v: [MembershipProductContextType, Dispatch<SetStateAction<MembershipProductContextType>>] | null,
) => {
  v = checkContext<MembershipProductContextType>(v);
  return v[1];
};

export type ProviderProps = {
  membershipProductContext: MembershipProductContextType;
  children: ReactNode;
};

const MembershipProductProvider: FC<ProviderProps> = ({ membershipProductContext, children }) => {
  const [appState, dispatch] = useState<MembershipProductContextType>(membershipProductContext);

  return (
    <MembershipProductContext.Provider value={[appState, dispatch]}>
      {children}
    </MembershipProductContext.Provider>
  );
};

export default MembershipProductProvider;
